import styled from 'styled-components';

import { device } from 'common/constants/mediaQueries';

export const Stack = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--s4);
`;

/** The design's `.repeat-item`, same object as the survey builder's. */
export const RepeatItem = styled.div`
  border: 1px solid var(--line);
  border-radius: var(--r-md);
  padding: var(--s4);
  background: var(--surface-alt);
`;

export const RepeatHead = styled.div`
  display: flex;
  align-items: center;
  gap: var(--s2);
  margin-bottom: var(--s4);
`;

export const RepeatN = styled.span`
  font-family: var(--font-mono);
  font-size: var(--fs-micro);
  color: var(--text-faint);
  background: var(--surface);
  border: 1px solid var(--line);
  padding: 2px 7px;
  border-radius: var(--r-sm);
`;

export const RepeatTitle = styled.span`
  font-family: var(--font-content);
  font-size: var(--fs-label);
  font-weight: var(--fw-semibold);
  color: var(--text);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const RepeatActions = styled.div`
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: var(--s1);
`;

export const Body = styled.div`
  display: flex;
  align-items: flex-start;
  gap: var(--s4);

  @media ${device.laptop} {
    flex-direction: column;
  }
`;

/*
 * The portrait sits in its own column at the head of the block rather than
 * being tucked behind the first field with `left: -15px`, which put the
 * uploader's own control outside the row it belonged to.
 */
export const Portrait = styled.div`
  flex: 0 0 auto;
  padding-top: 22px;
`;

export const Fields = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: var(--s3);
`;

export const Div = styled.div``;
